import React from "react";
import {AEquipment} from "../../models/equipments/AEquipment";
import {equipmentsTranslateKey} from "../../models/utils/EEquipmentType";
import DisplaySpecifications from "./DisplaySpecifications";
import DisplayElement from "./DisplayElement";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Equipment to display.
     */
    equipment: AEquipment
}

/**
 * Displays the attributes of equipment.
 * @author Alizée Grand
 * @version 1.1
 * @creation 31/05/2022
 * @last_update 11/07/2022
 **/
class DisplayEquipment extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        return (

            <React.Fragment>
                <span><b>{getTranslation("display.equipment.type")}</b> : {getTranslation(equipmentsTranslateKey[this.props.equipment.type])}</span>
                <br/>
                <span><b>{getTranslation("display.equipment.specs")}</b> : </span>
                <ul>
                    {
                        this.props.equipment.specifications.map((spec, index) => (
                            <li key={index}>
                                <DisplaySpecifications specifications={spec}/>
                            </li>
                        ))
                    }
                </ul>
                <span><b>{getTranslation("display.equipment.elements")}</b> : </span>
                <ul>
                    {
                        this.props.equipment.elements.map((element, index) => (
                            <li key={index}>
                                <DisplayElement element={element}/>
                            </li>
                        ))
                    }
                </ul>
            </React.Fragment>

        );

    };

}

export default withTranslation()(DisplayEquipment);
